var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showCES)?_c('Typeform',{attrs:{"form-id":_vm.idCES,"use-feature-flag":false,"hidden-fields":_vm.hiddenFields},on:{"handle-typeform-submit":_vm.typeFormUpdate,"handle-typeform-close":_vm.typeFormUpdate}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }